/* Copyright (c) 2021-2026, NVIDIA CORPORATION.  All rights reserved.
*
* NVIDIA CORPORATION and its licensors retain all intellectual property
* and proprietary rights in and to this software, related documentation
* and any modifications thereto.  Any use, reproduction, disclosure or
* distribution of this software and related documentation without an express
* license agreement from NVIDIA CORPORATION is strictly prohibited.
*/

/** This file was automatically generated. DO NOT MODIFY IT BY HAND. */

/* eslint-disable @typescript-eslint/naming-convention */

import { BridgeCommands } from '../../../src/bridge.commands';

import { Types } from '../../types/index';

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const MonitorLoginStatus: BridgeCommands.Command<
    {},
    any
    > = {
    legacyCommand: 'JARVIS_MONITOR_LOGIN_STATUS',
    system: 'CrimsonNative',
    module: 'Jarvis',
    method: 'MonitorLoginStatus',
    persistent: true
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const Login: BridgeCommands.Command<
    {},
    any
    > = {
    legacyCommand: 'JARVIS_LOGIN',
    system: 'CrimsonNative',
    module: 'Jarvis',
    method: 'Login',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const Logout: BridgeCommands.Command<
    {},
    any
    > = {
    legacyCommand: 'JARVIS_LOGOUT',
    system: 'CrimsonNative',
    module: 'Jarvis',
    method: 'Logout',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const QueryToken: BridgeCommands.Command<
    {},
    string | undefined
    > = {
    legacyCommand: 'QUERY_TOKEN',
    system: 'CrimsonNative',
    module: 'Jarvis',
    method: 'QueryToken',
    persistent: false
};

export const Jarvis = {
MonitorLoginStatus,
Login,
Logout,
QueryToken
};
